import 'babel-polyfill'

//
// Generic styling
//
import '@css/style.less'

//
// logger
//
import logger from '@/shared/logger.js'

//
// base application class
//
import application from './shared/application'

//
// include SVG icon sprite
//
const div = document.createElement('div')
const body = document.body
div.style.cssText = 'border: 0; clip: rect(0 0 0 0); height: 0; overflow: hidden; padding: 0; position: absolute; width: 0;'
div.innerHTML = require('!!html-loader!@img/icons.svg')
body.insertBefore(div, body.childNodes[0])



// WEBPACK FOOTER //
// ./resources/assets/front/js/common.js